<template>
  <div class="board">
    <div class="board__inner">
      <div class="board__field">
        <Field />
      </div>
      <div class="board__players">
        <div
          v-for="player in players"
          v-bind:key="player.key"
          class="board__player"
          v-bind:class="{
            'board__player--n': player.position === 'n',
            'board__player--o': player.position === 'o',
            'board__player--s': player.position === 's',
            'board__player--w': player.position === 'w'
          }"
        >
          <Player v-bind:player="player" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Player from '../components/shared/Player';
import Field from '../components/Field';
import Game from '../game/game';
export default {
  beforeMount() {
    const setup = this.game.init({
      players: this.$store.state.selectedPlayers,
      dfficulty: this.$store.state.selectedDifficulty,
      jokers: this.$store.state.selectedJokers
    });

    this.$store.dispatch(
      'setPlayers',
      this.game.playerPositions(setup.players)
    );

    this.$store.dispatch('setTableCards');

    this.$store.dispatch('setTableStock', [
      ...this.game.shuffle(setup.playingCards)
    ]);
  },
  data() {
    return {
      game: new Game()
    };
  },
  computed: mapState(['players']),
  components: {
    Player,
    Field
  }
};
</script>

<style lang="scss" scoped>
.board {
  position: relative;
  width: 100%;

  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  &__inner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 10px 0px,
      rgba(0, 0, 0, 0.05) 0px 1px 9px 0px;
    background-color: #fff;
  }

  &__field {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  &__players {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__player {
    position: absolute;
    display: flex;
    width: 100%;

    &--n {
      transform: rotate(180deg);
      top: 15px;
    }

    &--o {
      transform-origin: 100% 0;
      transform: rotate(-90deg) translate(0, calc(-100% - 15px));
    }

    &--s {
      bottom: 15px;
    }

    &--w {
      transform-origin: 0 0;
      transform: rotate(90deg) translate(0, calc(-100% - 15px));
    }
  }
}
</style>
